module.exports = __webpack_public_path__ + "static/media/arrow_navbar.1bfdc554.svg";